import { useState } from "react";
import { BackIcon } from "../components/icons";
import { joinUs } from "../api/authApi";
import { isApiSuccess } from "../utils/apiResponse";

const CC_OPTIONS = ["+63"];
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export default function JoinUsPage({ onClose, onFlash }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [cc, setCc] = useState("+63");
  const [mobile, setMobile] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [apiError, setApiError] = useState("");

  const nameOk = name.trim().length > 0;
  const emailOk = email.trim().length === 0 || EMAIL_RE.test(email);
  const mobileOk = mobile.replace(/\s/g, "").length >= 7;

  const submit = async () => {
    setSubmitted(true);
    setApiError("");
    if (!nameOk || !emailOk || !mobileOk) return;

    setSubmitting(true);
    try {
      const { data } = await joinUs(name, email, cc, mobile);
      if (!isApiSuccess(data)) {
        setApiError(data?.message || "Could not submit your request");
        return;
      }
      onFlash("Request submitted — we will be in touch");
      onClose();
    } catch (err) {
      setApiError(err.response?.data?.message || "Could not submit your request");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-col">
        <div className="auth-card auth-card--standalone">
          <div className="auth-card__header">
            <button type="button" className="auth-card__header-btn" aria-label="Back" onClick={onClose}>
              <BackIcon size={20} />
            </button>
            <h1>Join Us</h1>
          </div>
          {apiError && <div className="auth-error-banner">{apiError}</div>}
          <input
            className={"join-input" + (submitted && !nameOk ? " input-invalid" : "")}
            placeholder="Name*"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {submitted && !nameOk && <span className="field-error">Name is required</span>}
          <input
            className={"join-input" + (submitted && !emailOk ? " input-invalid" : "")}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {submitted && !emailOk && <span className="field-error">Enter a valid email address</span>}
          <div className="mobile-row" style={{ marginTop: 18 }}>
            <div className="country-code-field">
              <span className="country-code-field__label">Country Code</span>
              <select className="country-code-field__select" value={cc} onChange={(e) => setCc(e.target.value)}>
                {CC_OPTIONS.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>
            </div>
            <div className="mobile-row__input">
              <input
                className={submitted && !mobileOk ? "input-invalid" : ""}
                inputMode="numeric"
                placeholder="Mobile/Phone*"
                value={mobile}
                onChange={(e) => setMobile(e.target.value.replace(/[^0-9 ]/g, ""))}
              />
              {submitted && !mobileOk && <span className="field-error">Enter a valid mobile number</span>}
            </div>
          </div>
          <button type="button" className="join-cta" onClick={submit} disabled={submitting}>
            {submitting ? "Submitting…" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}
